export default __webpack_public_path__ + "static/media/spacewoman.408d80bf.jpeg";